import React from 'react'

interface IconProps {
  className?: string
  'aria-hidden'?: boolean
}

export const ContinentsIcon: React.FC<IconProps> = ({ className, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path 
      d="M17.3449 3.54675C16.7986 3.95161 16.4444 4.60111 16.4444 5.33333C16.4444 6.56063 15.4495 7.55556 14.2222 7.55556C12.9949 7.55556 12 8.55048 12 9.77778C12 11.0051 12.9949 12 14.2222 12C15.4495 12 16.4444 12.9949 16.4444 14.2222C16.4444 15.4495 17.4394 16.4444 18.6667 16.4444H20.9605M17.3449 3.54675C15.7989 2.56715 13.9657 2 12 2C6.85272 2 2.61375 5.88894 2.06103 10.8889M17.3449 3.54675C20.1427 5.31946 22 8.44283 22 12C22 17.5228 17.5228 22 12 22C9.61856 22 7.43155 21.1676 5.71407 19.7778M5.71407 19.7778L8.66667 19.7778C9.89397 19.7778 10.8889 18.7829 10.8889 17.5556C10.8889 16.3283 9.89397 15.3333 8.66667 15.3333C7.43937 15.3333 6.44445 14.3384 6.44445 13.1111C6.44445 11.8838 5.44952 10.8889 4.22222 10.8889H2.06103M5.71407 19.7778C3.44852 17.9445 2 15.1414 2 12C2 11.6244 2.0207 11.2537 2.06103 10.8889" 
      stroke="currentColor" 
      strokeWidth="1.5" 
      strokeLinecap="round"
    />
  </svg>
)